export const ANIMATED_COMPONENT_KEYS = {
  MAIN: 'MAIN',
  ZERO_SUBSCRIPTION: 'ZERO_SUBSCRIPTION',
  THANK_YOU: 'THANK_YOU',
};

export enum GET_CONTAINER_DISPLAY_M {
  LOADING = 'LOADING',
  BUY = 'BUY',
  SUBSCRIBE = 'SUBSCRIBE',
  SUBSCRIBE_STANDALONE = 'SUBSCRIBE_STANDALONE',
  GET_EMAIL = 'GET_EMAIL',
  GET_EMAIL_AND_PURCHASE = 'GET_EMAIL_AND_PURCHASE',
  NAME_YOUR_PRICE = 'NAME_YOUR_PRICE',
  FREE_DOWNLOAD_LINKS = 'FREE_DOWNLOAD_LINKS',
  NO_PURCHASE_AVAILABLE = 'NO_PURCHASE_AVAILABLE',
  DEMO_ALBUM = 'DEMO_ALBUM',
  START_PURCHASE = 'START_PURCHASE',
  CASHIER_LAZY_WIDGET = 'CASHIER_LAZY_WIDGET',
  PROCESSING_PAYMENT = 'PROCESSING_PAYMENT',
  PAYMENT_PENDING = 'PAYMENT_PENDING',
  DOWNLOAD_LINKS = 'DOWNLOAD_LINKS',
  ERROR = 'ERROR',
  PAYMENT_ERROR = 'PAYMENT_ERROR',
  ENTITY_NOT_GETTABLE = 'ENTITY_NOT_GETTABLE',
}
